var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('send-message-controller',_vm._g({attrs:{"recipient-ids":_vm.recipientIds,"allow-do-not-show-again":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var sending = ref.sending;
  var priceList = ref.priceList;
  var sendMessage = ref.sendMessage;
  var selectPrice = ref.selectPrice;
  var attachedFiles = ref.attachedFiles;
  var uploadingAttachment = ref.uploadingAttachment;
  var addAttachment = ref.addAttachment;
  var removeAttachment = ref.removeAttachment;
  var attachmentSelectedPrice = ref.attachmentSelectedPrice;
  var priceAmount = ref.priceAmount;
  var priceAmountText = ref.priceAmountText;
  var allowedPublicFilesCount = ref.allowedPublicFilesCount;
  var allowedPrivateFilesCount = ref.allowedPrivateFilesCount;
return [_c('message-send-with-attachment-view',{attrs:{"recipient-ids":_vm.recipientIds,"thread-id":_vm.threadId,"sending":sending,"price-amount":(priceAmount > 0 && priceAmountText) || undefined,"package-list":priceList,"files":attachedFiles,"attachment-price-id":attachmentSelectedPrice,"uploading-attachment":uploadingAttachment,"allowed-public-files-count":allowedPublicFilesCount,"allowed-private-files-count":allowedPrivateFilesCount},on:{"setPrice":selectPrice,"addAttachment":addAttachment,"removeAttachment":removeAttachment,"send":sendMessage}})]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }